(function () {
  'use strict';

  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      dashboard: {
        "dashboardHeader": "Početna strana",
        "addNewWidget1": "Označite",
        "addNewWidget2": "Favorite",
        "pendingPayments": "Nalozi na čekanju",
        "show": "Prikaži",
        "hide": "Sakrij",
        "domesticPaymentBtn1": "Nalog za",
        "domesticPaymentBtn2": "plaćanje",
        "transferBtn1": "Prenos na",
        "transferBtn2": "moj račun",
        "templateBtn1": "Plaćanje iz",
        "templateBtn2": "šablona",
        "quickPaymentTransfer": "Brzo plaćanje ili transfer",
        "domesticPayment": "Kreiraj opći nalog",
        "internalTransfer": "Kreiraj nalog za prenos",
        "payTemplate": "Plati predložak",
        "searchTemplatesPlaceholder": "Pretraži šablone",
        "showAccounts": "Prikaži još računa",
        "instantLoan": "Brzi kredit",
        "instantLoanDescription": "Da li ste znali da se možete prijaviti za brzi unaprijed odobreni novčani kredit do 10.000,00 RSD",
        "apply": "Prijava",
        "contact": "Kontaktirajte nas",
        "hypoClub": "Addiko Club",
        "etrade": "E-Trade",
        "branch": "Pronađite poslovnicu",
        "bankTimeline": "Vremenski prikaz Vašeg poslovanja",
        "loadEvents": "Učitaj starije događaje",
        "noTimelineData": "Za odabrani period nema podataka za prikaz",
        "availableBalance": "Raspoloživo stanje",
        "loanAmount":"Iznos kredita",
        "confirmation": "Potvrda",
        "complaint": "Reklamacija",
        "cashLoan": "Keš kredit",
        "approval": "odobrenje za 1 sat",
        "tydUnsubscribe": "Ukoliko više ne želite da primate direktne marketinške poruke na digitalnim kanalima, molimo Vas da nas o tome obavestite slanjem poruke sa tekstom \"Odjava\" putem funkcionalnosti \"Poruke\" unutar glavnog menija u sklopu aplikacije ili nas pozovite na brojeve telefona 0800 303 303 odnosno +381 11 222 60 00."
        },
      timelineFilter: {
        "placeholder": "Pretraga i filtriranje",
        "all": "Svi",
        "credit": "Uplate",
        "debit": "Isplate",
        "others": "Ostali",
        "amountFrom": "Iznos od",
        "amountTo": "Do",
        "reset": "Poništi",
        "apply": "Primeni"
      },
      header: {
        "dashboard": "Početna strana",
        "accounts": "Računi i kartice",
        "payments": "Plaćanja",
        "orders": "Narudžbe",
        "branches": "Poslovnice i bankomati",
        "settings": "Postavke",
        "notificationMessages": "Poruke",
        "notificationMessagesPlaceholder": "Napišite vaš odgovor",
        "notificationMessagesPlaceholderSubject": "Naslov poruke",
        "notificationMessagesUnread": "Nepročitana",
        "notificationMessagesMarkAsRead": "Označi kao pročitanu",
        "notificationMessagesReply": "Odgovori",
        "notificationMessagesSend": "Pošalji",
        "notificationMessagesCancelSend": "Odustani",
        "notificationMessagesViewAll": "Pregled svih poruka",
        "notificationEInvoices": "Novi eRačuni",
        "notificationEInvoicesDueDate": "datum naplate",
        "notificationEInvoicesPay": "Plati",
        "notificationEInvoicesViewAll": "Pregled svih eRačuna",
        "notificationPendingPayments": "Plaćanja u obradi",
        "notificationPendingPaymentsViewAll": "Pregled svih plaćanja",
        "notificationPendingPaymentsDateLabel": "datum",
        "notificationRejectedPayments": "Odbijena plaćanja",
        "notificationRejectedPaymentsViewAll": "Pregled svih plaćanja",
        "notificationRejectedPaymentsDateLabel": "datum",
        "notificationSettingsLangLabel": "Odaberite jezik:",
        "notificationSettingsViewAllLabel": "Otvorite postavke aplikacije",
        "signedInAs": "Prijavljeni korisnik",
        "lastLogin": "Datum zadnje prijave: ",
        "logout": "Odjava",
        "langEn": "Engleski",
        "langHr": "Hrvatski",
        "langSr": "Srpski",
        "langMtr": "Crnogorski",
        "langBa": "Lokalni",
        "langSl": "Slovenački",
        "langDe": "Njemački",
        "langRu": "Ruski",
        "noMessages": "Nema poruka",
        "noeInvoices": "Nema eRačuna",
        "noPendingPayments": "Nema uplata na čekanju",
        "noRejectedPayments": "Nema odbačenih uplata"
      },
      footer: {
        "freeCall": "Besplatni poziv",
        "internationalCall": "Internacionalni poziv",
        "email": "Pošaljite nam e-mail",
        "notificationDepth": "Dubinska analiza",
        "dearClients": "Poštovani,",
        "modalText1": "dozvolite da Vas informiramo o važnosti ažuriranja Vaših osobnih podataka kako bi se poslovni odnos i nadalje uspješno nastavio.",
        "modalText2": "Podaci kao što su broj i datum valjanosti osobnog identifikacijskog dokumenta (osobna iskaznica, putovnica, dozvola boravka u RH) potrebno je ažurirati u Vama najbližoj poslovnici Banke po isteku njihovog datuma važenja, a sve u skladu s čl.7., Općih uvjeta Addiko Bank d.d.",
        "modalText3": "U svrhu ispravne identifikacije te nužnog ažuriranja Vašeg identifikacijskog dokumenta bit ćemo slobodni obavijestiti Vas o navedenom putem dopisa poslanom na kućnu adresu i/ili porukom proslijeđenom kanalima direktnog bankarstva.",
        "regards": "Srdačan pozdrav",
        "closeButton": "Zatvori",
        "version":"Verzija",
        "server":"Server"
      },
      timeline: {
        msgWith: "Message with subject ",
        msgWithout: "message without subject ",
        msgReceived: " was received on ",
        msgSent: " was sent on "
      },
      templateSearch: {
        favorites: "Favoriti",
        templatesList: "Šabloni"
      },
      dashboardWidgets: {
        current: "Tekući računi i kartice",
        loan: "Krediti",
        deposit: "Štednja",
        savings: "Štedni računi",
        giro: "Žiro računi",
        addBtn: "Potvrdi"
      },
      dashboardNotification: {
        rejected: "odbijenih naloga",
        einvoice: "neplaćenih eRačuna",
        group: "grupnih naloga za potpisati",
        goBtn: "Idi na plaćanja",
        unsigned: "Nepotpisanih naloga"
      }
    };

    $translateProvider
      .translations('sr', data);
  }
}());
